// @ts-nocheck
import { useState } from 'react';
import { connect } from 'react-redux';
import { Translate, translate } from 'react-i18nify';
import { PRIVILEGED_AUTHORITIES, HIDDEN_AUTHORITIES, NULL_GUID } from '../../../constants';
import { decamelize, isCaregiver } from '../../../utils';
import SaveableMultiSelect from '../../SaveableMultiSelect';
import Button from '../../Button';
import Modal from '../../Modal';
import {
  toggleHiddenCounty,
  clearHiddenCounties,
  toggleAuthority,
  clearAuthorities,
  updateAuthorities,
  updateHiddenSources,
  updateHiddenCounties,
  clearHiddenSources,
  toggleHiddenSource
} from '../../../actions';

const SystemUserPermissions = (props) => {
  const [authoritiesModalVisible, setAuthoritiesModalVisible] = useState(false);
  const highlightedAuthorities = ['caregiver', 'nurse', 'healthscientist'];
  const { authorityTypes: authority, sources, counties, authorities } = props.sharedData;
  const { currentSystemUser, updatingHiddenSources, updatingHiddenCounties, currentSystemUserAuthorities } =
    props.systemUsers;

  const onDisallowedCountyChange = (_, event) => {
    switch (event.action) {
      case 'clear':
        props.clearHiddenCounties();
        break;
      case 'remove-value':
        props.toggleHiddenCounty(event.removedValue.value);
        break;
      case 'select-option':
        props.toggleHiddenCounty(event.option.value);
        break;
      default:
        return;
    }
  };

  const onDisallowedSourceChange = (_, event) => {
    switch (event.action) {
      case 'clear':
        props.clearHiddenSources();
        break;
      case 'remove-value':
        props.toggleHiddenSource(event.removedValue.value);
        break;
      case 'select-option':
        props.toggleHiddenSource(event.option.value);
        break;
      default:
        return;
    }
  };

  const onAuthoritiesChange = (event) => {
    props.toggleAuthority(event.target.value);
  };

  const saveAuthorites = () => {
    const { updateAuthorities, authToken, match, systemUsers } = props;

    const updatedFields = {
      user: {},
      systemUserExtras: {
        authorities: systemUsers.currentSystemUserAuthorities
      }
    };

    updateAuthorities(authToken, match.params.memberId, updatedFields);

    setAuthoritiesModalVisible(false);
  };

  const saveHiddenSources = () => {
    const { updateHiddenSources, authToken, match, systemUsers } = props;

    const updatedFields = {
      user: {},
      systemUserExtras: {
        hiddenSources: systemUsers.currentSystemUserHiddenSources
      }
    };

    updateHiddenSources(authToken, match.params.memberId, updatedFields);
  };

  const saveHiddenCounties = () => {
    const { updateHiddenCounties, authToken, match, systemUsers, sharedData } = props;

    const updatedFields = {
      user: {},
      systemUserExtras: {
        hiddenCounties: sharedData.counties.filter(
          (county) => systemUsers.currentSystemUserHiddenCountyIds.indexOf(county.countyCode) > -1
        )
      }
    };

    updateHiddenCounties(authToken, match.params.memberId, updatedFields);
  };

  const readableAuthorities = authorities
    .map((authority) => ({
      authority,
      readable: translate(`authorities.${decamelize(authority, '_')}`)
    }))
    .sort((a, b) => {
      if (a.readable > b.readable) {
        return 1;
      }

      if (a.readable < b.readable) {
        return -1;
      }

      return 0;
    });

  return (
    <>
      <div className="card-header">
        <div className="flex space-between">
          <Translate value="global.authorities" />
          <span className="card-actions fs-15">
            <Button
              buttonType="text"
              onClick={() => setAuthoritiesModalVisible(true)}
              disabled={currentSystemUser?.guid === props.user?.guid}
            >
              <Translate value="global.buttons.edit" />
            </Button>
          </span>
        </div>
      </div>
      <div className="mb-30">
        <div className="authority-columns">
          <div>
            {currentSystemUser && currentSystemUser.authorities && currentSystemUser.authorities.length ? (
              <ul className="check-list">
                {currentSystemUser.authorities
                  .filter((authority) => authority && !HIDDEN_AUTHORITIES.includes(authority))
                  .map((authority) => (
                    <li key={authority} className={highlightedAuthorities.includes(authority) ? 'fw-600' : undefined}>
                      {translate(`authorities.${decamelize(authority, '_')}`)}
                    </li>
                  ))}
              </ul>
            ) : (
              <span>Inga rättigheter.</span>
            )}
          </div>
        </div>
      </div>
      {isCaregiver(currentSystemUser) ? (
        <>
          <h4>
            <Translate value="system_user_details.disallowed_sources" />
          </h4>
          <div className="mb-30">
            <SaveableMultiSelect
              requiredAuthority={authority.manageUsers}
              isSaving={updatingHiddenSources}
              onSave={saveHiddenSources}
              actionI18nKey="global.buttons.save"
              name="hidden-sources"
              placeholderI18nKey="global.choose"
              defaultValue={
                currentSystemUser.hiddenSources && currentSystemUser.hiddenSources.length
                  ? currentSystemUser.hiddenSources.map((source) => {
                      return { value: source, label: source };
                    })
                  : []
              }
              currentValue={props.systemUsers.currentSystemUserHiddenSources}
              noOptionsI18nKey="system_user_details.no_more_sources"
              onChange={onDisallowedSourceChange}
              options={sources.map((source) => {
                return { value: source, label: source };
              })}
            />
          </div>
          <h4>
            <Translate value="system_user_details.disallowed_regions" />
          </h4>
          <div className="mb-30">
            <SaveableMultiSelect
              requiredAuthority={authority.manageUsers}
              isSaving={updatingHiddenCounties}
              onSave={saveHiddenCounties}
              actionI18nKey="global.buttons.save"
              name="disallowed-regions"
              placeholderI18nKey="global.choose"
              defaultValue={
                currentSystemUser.hiddenCounties && currentSystemUser.hiddenCounties.length
                  ? currentSystemUser.hiddenCounties.map((county) => {
                      return { value: county.countyCode, label: county.countyName };
                    })
                  : []
              }
              currentValue={props.systemUsers.currentSystemUserHiddenCountyIds}
              noOptionsI18nKey="system_user_details.no_more_regions"
              onChange={onDisallowedCountyChange}
              options={counties
                .filter((county) => county.countyCode.indexOf('null') === -1)
                .map((county) => {
                  return { value: county.countyCode, label: county.countyName };
                })}
              fallbackKey="label"
            />
          </div>
        </>
      ) : null}
      <Modal
        visible={authoritiesModalVisible}
        actionCompletable={true}
        headerI18nKey="global.authorities"
        actionI18nKey="global.buttons.save"
        onClose={() => setAuthoritiesModalVisible(false)}
        onActionCompleted={saveAuthorites}
        additionalFooterContent={
          <div className="mb-10">
            <Translate value="system_user_details.authority_update_notice" />
          </div>
        }
      >
        <div className="stack">
          {readableAuthorities.map((a, i) => {
            const isDoctor = currentSystemUserAuthorities.includes('caregiver');
            const isNurse = currentSystemUserAuthorities.includes('nurse');
            const lackingPrivilege =
              PRIVILEGED_AUTHORITIES.includes(a.authority) && !props.authorities.includes('manageCaregivers');
            const authorityDisabled =
              lackingPrivilege || (a.authority === 'caregiver' && isNurse) || (a.authority === 'nurse' && isDoctor);

            return (
              <div className="authority-container" key={i}>
                <input
                  type="checkbox"
                  value={a.authority}
                  id={`authority-${i}`}
                  checked={currentSystemUserAuthorities.includes(a.authority)}
                  onChange={onAuthoritiesChange}
                  disabled={authorityDisabled}
                />
                <label htmlFor={`authority-${i}`}>
                  {a.readable}
                  <div className="authority-description">
                    <Translate value={`authority_description.${decamelize(a.authority, '_')}`} />
                  </div>
                </label>
              </div>
            );
          })}
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    authToken: state.auth.token.jwt,
    systemUsers: state.systemUsers,
    sharedData: state.sharedData,
    authorities: state.auth.authorities,
    user: state.auth.token.user
  };
};

const mapActionsToProps = {
  toggleHiddenCounty,
  clearHiddenCounties,
  toggleAuthority,
  clearAuthorities,
  updateAuthorities,
  updateHiddenSources,
  updateHiddenCounties,
  clearHiddenSources,
  toggleHiddenSource
};

export default connect(mapStateToProps, mapActionsToProps)(SystemUserPermissions);
